import { Component } from '@angular/core';
import { BalanceModel } from 'src/app/models/balance-model';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { ResponsibleGamingService } from 'src/app/services/responsible-gaming-service/responsible-gaming.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
    selector: 'app-limits-history',
    templateUrl: './limits-history.component.html',
    styleUrls: ['./limits-history.component.scss'],
})
export class LimitsHistoryComponent {
    public limitTypeArray: string[] = ["DEPOSIT_LIMIT", "SPEND", "TIME", "WAGER", "LOSS"];
    public limitTypeSelected: string = this.limitTypeArray[0];
    public limitsHistory: any[] = [];
    public filteredLimitHistory: any[] = [];
    public showTable: boolean = false;
    public error = null;
    public currency: any;

    public PIPE_FORMAT_FULLDATE_TIME_SECOND = this.config.getConfig().FORMAT_TIME_FULLDATE_TIME_SECOND ?? 'MM/dd/yyyy hh:mm:ss a';

    constructor(
        private responsibleGamingProvider: ResponsibleGamingService,
        public utils: UtilsService,
        protected config: ConfigService,
        public accountBalanceService: AccountBalanceService,
    ) {
        this.getLimitHistory(this.limitTypeArray[0]);

        // we need to get currency
        this.accountBalanceService.getBalance().subscribe((response: BalanceModel) => {
            this.currency = response.getDefaultCurrency();
        });
        //Adjusting the default selected tab for Win/Loss tab navigation vs default tab navigation - KND 1722
        // if (navParams.get('navigationFromWinLoss')) {
        //     this.getLimitHistory(this.limitTypeArray[1]);
        // } else {
        //     this.getLimitHistory(this.limitTypeArray[0]);
        // }
    }

    getLimitHistory(limitType: string) {
        this.limitTypeSelected = limitType;
        let limitSubType: string;

        //This code below looks a bit confusing but has to be done because both SPEND and WAGER limits use "WAGER" as the LIMIT TYPE from
        //the service call, so we have to differentiate between the TERM TYPE "SINGLE" which belongs to "WAGER" and the term types "DAILY/WEEKLY/MONTHLY"
        //which belong to "SPEND"

        if (limitType == "SPEND") {
            limitType = "WAGER";
            limitSubType = "SPEND";
        }
        else if (limitType == "WAGER") {
            limitSubType = "WAGER";
        }

        this.responsibleGamingProvider.getLimitHistory().subscribe({
            next: (response: any) => {
                if (response && !!response.result) {
                    const tempLimitsHistory: any = response.payload;
                    this.limitsHistory = [];
                    for (const i in tempLimitsHistory) {
                        if (tempLimitsHistory[i] != null && tempLimitsHistory[i].limitType === limitType && tempLimitsHistory[i].limitSource != "GLOBAL") {
                            if (limitSubType == "SPEND") {
                                if (tempLimitsHistory[i].currentLimitTermType != "SINGLE") {
                                    this.limitsHistory.push(tempLimitsHistory[i]);
                                }
                            }
                            else if (limitSubType == "WAGER") {
                                if (tempLimitsHistory[i].currentLimitTermType == "SINGLE") {
                                    this.limitsHistory.push(tempLimitsHistory[i]);
                                }
                            }
                            else {
                                this.limitsHistory.push(tempLimitsHistory[i]);
                            }
                        }
                    }

                    //remove duplicated values
                    this.filteredLimitHistory = this.limitsHistory.filter((item, index, array) => array.findIndex(
                        (pos) => {
                            return (pos.newLimit ===
                                item.newLimit && pos.currentLimitTermType ===
                                item.currentLimitTermType && pos.startPeriod ===
                                item.startPeriod && pos.endPeriod ===
                                item.endPeriod && (!pos?.nextNewLimit || pos?.nextNewLimit && !pos.oldLimit))
                        }) ===
                        index).sort((a, b) => {
                            const transFormFunc = function (trans) {
                                switch (trans) {
                                    case "DAILY":
                                        return 1;
                                    case "WEEKLY":
                                        return 2;
                                    case "MONTHLY":
                                        return 3;
                                }
                            }

                            return a.startPeriod - b.startPeriod || transFormFunc(a.currentLimitTermType) - transFormFunc(b.currentLimitTermType);
                        });
                    //remove the Global limitSource(default limit setting) for jira 516, because no limitSoucre property in those array
                    // this.filteredLimitHistory = this.filteredLimitHistory.filter(item => item.limitSource);

                    if (this.filteredLimitHistory.length > 0) {
                        this.showTable = true;
                    }
                    else {
                        this.showTable = false;
                    }
                }
            },
            error: (error) => {
                this.error = error;
            }
        });
    }

}
